import { FormattedImageProps } from "./formatted-image-types";

const FormattedImage: React.FC<FormattedImageProps> = ({ webpSrc, fallbackSrc, alt, ...props }) => {
    return (
        <picture style={{ display: 'flex', alignItems: 'center', margin:'0px', padding: '0px'}}>
            <source srcSet={webpSrc} type="image/webp" />
            <source srcSet={fallbackSrc} type="image/png" />
            <img src={fallbackSrc} alt={alt} {...props} />
        </picture>
    );
};
    
export default FormattedImage;